/* eslint-disable import/extensions */
import React from 'react';
import PopRefer from './PopRefer.js';
import Refer from './index.js';

class ReferWithUnit extends PopRefer {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			unit: props.defaultUnitValue || props.unitValue || {},
		};
	}

	componentDidUpdate(prevProps, prevState) {
		super.componentDidUpdate(prevProps, prevState);
		if (this.props.hasOwnProperty('unitValue')) {
			if (this.props.unitValue?.refpk !== prevProps.unitValue?.refpk) {
				this.setState({ unit: this.props.unitValue });
			}
		}
	}

	renderPopoverHeaderExtend = () => {
		const { unitProps, isShowUnit, unitCondition, unitPropsExtend, onUnitChange, attrcode } = this.props;
		if (unitProps && !unitProps.fieldid) {
			unitProps.fieldid = attrcode ? 'attrcode' + 'unit' : 'unit';
		}
		let props = { ...unitProps };
		if (unitPropsExtend) {
			props = { ...unitProps, ...unitPropsExtend };
		}
		if (unitCondition) {
			props = { ...unitProps, queryCondition: unitCondition };
		}
		let hotKeyMap = this.getHotKeyMap();
		return (
			isShowUnit && (
				<div
					style={{ width: '200px', marginLeft: '20px' }}
					className='cancel-drag'
				>
					<Refer
						{...props}
						value={this.state.unit}
						onChange={(value, foolValue) => {
							// this.loadSelectedData();
							//树表参照切换业务单元的时候要查常用
							onUnitChange?.(value, foolValue);
							this.setState(
								{ unit: value },
								() => {
									let isCheckUsual = true;
									this.show(true, false,isCheckUsual);
								},
							);
						}}
						popWindowClassName="refer-unit-pop-window"
						container={this.props.container}
						baseTabIndex={this.getTabIndex(
							[
								...hotKeyMap.keys(),
							][hotKeyMap.size - 1],
						)}
						tabIndex={this.getTabIndex(this.hotKeyElement.unit)}
						onFocus={() => {
							this.unitReferFocusFlag = true;
						}}
						onBlur={() => {
							this.unitReferFocusFlag = false;
						}}
						showCodeWhenFocus={false}
					/>
				</div>
			)
		);
	};
}

export default ReferWithUnit;
